var _style, _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 667.5 170.4",
    style: {
      enableBackground: "new 0 0 667.5 170.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:url(#SVGID_1_);}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M219.8,47.7h-29.4c-20.4,0-37,16.6-37,37v1.7c0,20.4,16.6,37,37,37h29.4c20.4,0,37-16.6,37-37v-1.7 C256.8,64.3,240.2,47.7,219.8,47.7z M243.7,86.3c0,13.2-10.7,23.9-23.9,23.9h-29.4c-13.2,0-23.9-10.7-23.9-23.9v-1.7 c0-13.2,10.7-23.9,23.9-23.9h29.4c13.2,0,23.9,10.7,23.9,23.9V86.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M346.5,47.7h-57l8.1,13.1h49c13.6,0,24.7,11.1,24.7,24.7s-11.1,24.7-24.7,24.7h-49l-8.1,13.1h57 c20.8,0,37.8-17,37.8-37.8S367.4,47.7,346.5,47.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M413,85.5c0,20.8,17,37.8,37.8,37.8h57l-8.1-13.1h-49c-13.6,0-24.7-11.1-24.7-24.7s11.1-24.7,24.7-24.7h49 l8.1-13.1h-57C430,47.7,413,64.7,413,85.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452,
    y: 79,
    className: "st0",
    width: 47.7,
    height: 13.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "548.2,48.5 548.2,63.8 585.8,85.5 548.2,107.2 548.2,122.5 599,93.1 649.8,122.5 649.8,107.2  612.2,85.5 649.8,63.8 649.8,48.5 599,77.9  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 18.1769,
    y1: 85.5,
    x2: 120.2844,
    y2: 85.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00F899"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00A9F6"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M116.5,31.1L69.2,58.4L22,31.1c-1.7,1-2.1,1.2-3.8,2.2v32.3l19.3,11.2l8.5,4.9c2.5,0,4.5,0,7.1,0l8.5-4.9 l46.7-27v15.8l-29.5,17l-5,2.9l5,2.9l29.5,17v15.8l-46.7-27l-8.5-4.9c-2.5,0-4.5,0-7.1,0l-8.5,4.9l-19.3,11.2v32.3 c1.7,1,2.1,1.2,3.8,2.2l47.3-27.3l47.3,27.3c1.7-1,2.1-1.2,3.8-2.2v-32.3l-34.6-20l34.6-20V33.3C118.6,32.3,118.2,32.1,116.5,31.1z  M49.5,69.8L30.2,58.6V42.8l33,19.1L49.5,69.8z M30.2,128.2v-15.8l19.3-11.2l13.7,7.9L30.2,128.2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8209bf44.svg";
export { ForwardRef as ReactComponent };